import { connect } from 'react-redux'

import PromotionsTable from '../../components/promotions/PromotionsTable'

import { getPromotionsList, deletePromotion, archivePromotion, actionCreators } from '../../state/actions/organizations'
import { getOrgPromotions } from '../../state/selectors'
import { IStoreState, IPromotion, IPromotionFilter } from '../../types/index'
interface IPromotionsTableProps {
  orgId: string
}

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    routeProps: ownProps,
    isActive: ownProps.isActive,
    loading: state.organizationPromotions.metadata.fetchingList,
    promotions: getOrgPromotions(state, ownProps.orgId, ownProps.isActive),
    services: state.service.items,
    products: state.providerProduct.items,
    filters: state.organizationPromotions.filters,
    promotionCount: state.organizationPromotions.promotionCount
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getAllPromotions: (params: IPromotionFilter) => dispatch(getPromotionsList(params)),
    deletePromotion: (promotionId: string) => dispatch(deletePromotion(promotionId)),
    updatePromotionFilters: (params: IPromotionFilter) => dispatch(actionCreators.updatePromotionFilters(params)),
    archivePromotion: (promotionId: string) => dispatch(archivePromotion(promotionId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionsTable)



// WEBPACK FOOTER //
// ./src/containers/promotions/PromotionsTable.ts